import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiBinBoxList } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/binBox/getData', async datas => {
    const { data } = await apiBinBoxList(datas)
    return data
})

export const binBoxSlice = createSlice({
    name: 'admin/binBox',
    initialState: {
        loading: true,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
    },
})

export const { setData, setTableData } = binBoxSlice.actions

export default binBoxSlice.reducer
